// @flow
import * as React from 'react';

import { useMatch } from 'react-router-dom';
import { View, Stepper, Icon } from 'reshaped';

import { useTranslator } from '@gandi/translate';
import { Svg } from '@gandi/ui';

import GandiShop from './GandiShop';

import styles from './StudioControls.scss';

export type FunnelControlsProps = {
  /**
   * 1. Address
   * 2. Summary
   * 3. Payment
   * 4. Payment failed
   * 5. Confirmation (payment return success) – no breadcrumbs or menu displayed
   */
  currentStep?: 1 | 2 | 3 | 4 | 5,
};

export function StudioControls({
  currentStep = 1,
}: FunnelControlsProps): React.MixedElement {
  const { __ } = useTranslator();

  const isStudioAccountPage = Boolean(useMatch('/studio/:cartId/account'));

  const steps = React.useMemo(
    () => [__('Address'), __('Summary'), __('Payment')],
    [__],
  );
  const stepperStep = Math.min(currentStep, steps.length);

  return (
    <div className={styles.root}>
      <div className={styles.studioControls}>
        {isStudioAccountPage ? (
          <Svg
            // needed for the display title
            id="gandi-net-logo"
            name="gandiIcon"
            theme="neutral-strong"
            className={styles.logo}
          />
        ) : (
          <Icon svg={GandiShop} size={7} />
        )}
        {isStudioAccountPage && currentStep !== 5 && (
          <View
            maxWidth={{
              s: 4,
              m: 300,
            }}
            width="100%"
            justify="center"
            align="center"
            grow
            paddingInline={{
              s: 1,
              m: 4,
              l: 8,
            }}
          >
            <Stepper
              className={styles.stepper}
              activeId={currentStep - 1}
              labelDisplay={{ s: 'hidden', m: 'inline' }}
              direction="row"
            >
              {steps.map((title, index) => (
                <Stepper.Item
                  key={title}
                  title={title}
                  completed={index < stepperStep - 1}
                />
              ))}
            </Stepper>
          </View>
        )}
      </div>
    </div>
  );
}
